<!--
 * @Author: your name
 * @Date: 2020-05-26 11:41:15
 * @LastEditTime: 2020-06-09 15:42:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\website\src\views\about\contact.vue
-->
<template>
  <div class="yqh_contact">
    <div class="contact">
      <div class="address">
        <div class="title">
          <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/About/contact/icon_1.png" />
          <div class="titlename">公司地址</div>
          <!-- <p class="yqh">公司地址</p> -->
        </div>
        <div class="right">
          <div id="mapContainer" style="width:100%;height:450px"></div>
          <el-tabs
            tab-position="bottom"
            stretch
            style="margin-top: 25px;"
            @tab-click="handleTab"
            v-model="activeName"
          >
            <el-tab-pane
              v-for="item in map"
              :key="item.city.substring(0,2)"
              :label="item.city.replace('市','')"
              :name="item.city+item.area+item.address"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <div class="message" v-for="(item,index) in map" :key="index">
          <!-- <p>{{mapInfo.city+mapInfo.area}}</p> -->
          <div class="message_p">
            <p>{{item.address}}</p>
            <p>邮编：{{item.email}}</p>
            <p>服务热线：{{item.phone}}</p>
          </div>
        </div>
      </div>
      <div class="business">
        <div class="title">
          <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/About/contact/icon_2.png" />
          <div class="titlename">业务咨询</div>
        </div>
        <div class="message">
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="6">
              <div class="name">*您的姓名:</div>
              <el-input v-model="demandInfo.name" placeholder="请输入您的姓名"></el-input>
            </el-col>
            <el-col :span="6">
              <div class="name">*您的电话:</div>
              <el-input v-model="demandInfo.phone" placeholder="请输入您的电话"></el-input>
            </el-col>
            <el-col :span="6">
              <div class="name">*业务类别:</div>
              <el-select v-model="demandInfo.sid" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
        <div class="ts">
          <div class="hint">*完善以上信息后，我们的顾问将在24小时内（工作日）与您进行沟通。我们会严格保密您的信息，并承诺只作为与我们联络使用。</div>
          <el-button @click="addDemand">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "",
      map: [],
      mapInfo: "",
      options: [],
      demandInfo: {
        name: "",
        phone: "",
        sid: ""
      }
    };
  },

  methods: {
    bdMap(detail, city) {
      //创建地图
      let map = new BMap.Map("mapContainer");
      let point = new BMap.Point((116.404, 39.915), 11);
      map.centerAndZoom(point, 20); // 创建点坐标
      map.addControl(new BMap.NavigationControl());
      map.enableScrollWheelZoom(true); //允许鼠标滚动缩放
      // 初始化地图， 设置中心点坐标和地图级别
      // 创建地址解析器实例
      var myGeo = new BMap.Geocoder();
      // 将地址解析结果显示在地图上，并调整地图视野
      myGeo.getPoint(
        detail,
        function(point) {
          if (point) {
            map.centerAndZoom(point, 18);
            map.addOverlay(new BMap.Marker(point));
          }
        },
        city
      );
    },
    handleTab(tab) {
      this.bdMap(tab.name, tab.label);
      console.log(this.map[tab.index]);
      this.mapInfo = this.map[tab.index];
    },
    getCompanyList() {
      let that = this;
      that.$http
        .post("website/getCompanyList")
        .then(function(res) {
          console.log(res);
          if (res.data.errorCode == 200) {
            that.map = res.data.data;
            that.bdMap(
              that.map[0].city + that.map[0].area + that.map[0].address,
              that.map[0].city
            );
            that.activeName =
              that.map[0].city + that.map[0].area + that.map[0].address;
            that.mapInfo = that.map[0];
          } else {
            that.$message.error(res.data.errorMsg);
          }
        })
        .catch(function(e) {
          // console.log(e);
        });
    },
    getServiceTypeList() {
      let that = this;
      that.$http
        .post("website/getServiceTypeList")
        .then(function(res) {
          if (res.data.errorCode == 200) {
            that.options = res.data.data;
          } else {
            that.$message.error(res.data.errorMsg);
          }
        })
        .catch(function(e) {
          // console.log(e);
        });
    },
    addDemand() {
      let that = this;
      if (!that.demandInfo.name) {
        that.$message.error("姓名必填");
        return;
      }
      if (!that.demandInfo.phone) {
        that.$message.error("电话必填");
        return;
      }
      if (!that.demandInfo.sid) {
        that.$message.error("业务类别必选");
        return;
      }
      let map = {
        name: that.demandInfo.name,
        phone: that.demandInfo.phone,
        sid: that.demandInfo.sid
      };
      console.log(map);
      that.$http
        .post("website/addDemand", map)
        .then(function(res) {
          if (res.data.errorCode == 200) {
            that.$message.success(res.data.errorMsg);
            that.demandInfo.name = "";
            that.demandInfo.phone = "";
            that.demandInfo.sid = "";
          } else {
            that.$message.error(res.data.errorMsg);
          }
        })
        .catch(function(e) {
          // console.log(e);
        });
    }
  },

  mounted() {},
  created() {
    let that = this;
    that.getCompanyList();
    that.getServiceTypeList();
  }
};
</script>
<style lang='less'>
.yqh_contact {
  width: 100%;
  padding-bottom: 80/16rem;
  box-sizing: border-box;
  .contact {
    width: 1100px;
    margin: 0 auto;

    .address {
      width: 100%;
      margin-top: 100px;
      overflow: hidden;
      .title {
        color: #333333;
        font-size: 18px;
        margin-bottom: 30/16rem;
        font-weight: bold;
        display: flex;
        align-items: center;
      }
      .right {
        .el-tabs__active-bar {
          height: 8px;
          background-color: #0c6ef5;
          top: 0;
        }
        .el-tabs__item {
          color: #666666;
          font-size: 16px;
          font-weight: bold;
          margin-top: 10/16rem;
          padding: 0;
        }
        .el-tabs__item.is-active {
          color: #0c6ef5;
          margin-top: 10/16rem;
        }
        .el-tabs__nav-wrap::after {
          position: absolute;
          top: 0;
        }
        .el-tabs__nav.is-stretch > * {
          text-align: left;
        }
      }
      .message {
        width: 100%;
        color: #999999;
        font-size: 15px;
        line-height: 25px;

        .message_p {
          float: left;
          width: 50%;
        }
      }
    }
    .business {
      width: 1200px;
      margin-top: 150/16rem;
      margin-bottom: 15/16rem;
      .title {
        color: #333333;
        font-size: 18px;
        margin-bottom: 30/16rem;
        font-weight: bold;
        display: flex;
        align-items: center;
      }
      .message {
        width: 100%;
        margin-bottom: 50/16rem;

        .name {
          color: #333333;
          font-size: 16px;
          margin-bottom: 20/16rem;
        }
      }
      .ts {
      
        .hint {
          color: #cccccc;
        }
        .el-button {
          width: 180/16rem;
          margin: 20/16rem 0;
          background-color: #0C6EF5;
          color: white;
        }
      }
    }
  }
}
</style>
